import classNames from 'classnames'
import React from 'react'

import { MenuItem, MenuItemProps } from '../menu-item/menu-item.js'

export interface MenuProps {
    className?: string
    items: MenuItemProps[]
}

export const Menu = (props: MenuProps) => (
    <nav className={classNames('menu', props.className)}>
        {props.items.map((item, index) => (
            <MenuItem key={index} {...item} />
        ))}
    </nav>
)
